<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import CounterVideoWallView from './CounterVideoWallView.vue';

const route = useRoute();
const stationSlug = computed(() => route.params.stationSlug as string);
const stationAuthCode = computed(() => {
  const code = route.query.code;
  return typeof code === 'string' && /^\d{6}$/.test(code) ? code : undefined;
});
</script>

<template>
  <CounterVideoWallView :station-slug="stationSlug" :station-auth-code="stationAuthCode" />
</template>
